module.exports = __webpack_public_path__ + "img/palmas-hotel.d954a8de.jpg";